import { topicTags, hotKeywords } from "@/mocks/topics";
import SectionHeading from "@/pages/home/components/SectionHeading";

interface TopicSectionProps {
  activeTopic: string;
  onSelectTopic: (id: string) => void;
  onSearchKeyword: (keyword: string) => void;
}

export default function TopicSection({ activeTopic, onSelectTopic, onSearchKeyword }: TopicSectionProps) {
  return (
    <section id="topics" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="TOPIC WALL"
          title="话题墙 · 按兴趣直达"
          desc="全部话题按热度排列，点选任意标签即可筛选下方「今日瓜讯」，热门搜索词同样可以直接跳转。"
          icon="ri-price-tag-3-line"
        />

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topicTags.map((tag) => {
            const active = activeTopic === tag.id;
            return (
              <button
                key={tag.id}
                type="button"
                onClick={() => onSelectTopic(tag.id)}
                className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg border px-4 py-2.5 text-sm font-medium transition-colors ${
                  active
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-200 bg-background-50 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                <i className="ri-hashtag text-base"></i>
                {tag.label}
                <span
                  className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${
                    active ? "bg-background-50/25 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {tag.count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4 md:mt-8 md:p-5">
          <div className="mb-3 flex items-center gap-2">
            <i className="ri-search-eye-line text-lg text-accent-600"></i>
            <h3 className="text-sm font-bold text-foreground-950">热门搜索</h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {hotKeywords.map((keyword) => (
              <button
                key={keyword}
                type="button"
                onClick={() => onSearchKeyword(keyword)}
                className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-800 transition-colors hover:bg-secondary-200"
              >
                {keyword}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}